<div class="main" [ngClass]="{ focusMode: isFocusMode }">
  <hs-app-container
    appTitle="Helios"
    [env]="env"
    [region]="region"
    attr.data-cy-initialized="{{ isInitialized }}"
    appIconUrl="/helios/assets/HeliosLogo.svg"
    [errorLogSize]="errorLogSize"
  >
    <hs-app-header-button-container #copilot></hs-app-header-button-container>
    <hs-notifications-bell
      hsAppHeaderEnd
      *ngIf="hasAccessNotifications"
      [commentLinksEnabled]="hasAccessCommentary"
      (commentLink)="openCommentLink($event)"
    ></hs-notifications-bell>

    <hs-app-header-button
      icon="chat-outline"
      *ngIf="hasAccessCommentary"
      (click)="onCommentsHeaderClick()"
      [badgeCount]="commentActivityCount"
      >Comments</hs-app-header-button
    >
    <hs-app-header-button
      icon="help"
      *ngIf="!isProd"
      [isActive]="isZoomInHelpActive"
      (click)="toggleZoomInHelp()"
      >Help</hs-app-header-button
    >
    <hs-app-header-button
      icon="keyboard"
      (click)="toggleHeliosEndNav('CommandsDrawer')"
      [isDisabled]="commandsDisabled"
      [badgeCount]="commandCount"
      badgeColor="yellow"
      [isLoading]="commandsLoading"
      >Commands</hs-app-header-button
    >
    <hs-app-header-button
      icon="monitor-dashboard"
      (click)="toggleHeliosEndNav('WorkspaceCatalog')"
      >Workspaces</hs-app-header-button
    >
    <hs-app-header-button
      icon="view-grid-plus-outline"
      (click)="toggleHeliosEndNav('PanelCatalog')"
      >Panels</hs-app-header-button
    >
    <hs-app-header-button
      icon="progress-clock"
      (click)="toggleHeliosEndNav('SessionsDrawer')"
      [isLoading]="isCreatingSession"
      [badgeCount]="sessionsCount"
      >Sessions</hs-app-header-button
    >

    <hs-app-gear-action (click)="toggleHeliosEndNav('UserPreferences')"
      >User Preferences</hs-app-gear-action
    >
    <hs-app-gear-action (click)="hotkeysHelpService.toggleHotkeysHelp()"
      >Hotkey Shortcuts</hs-app-gear-action
    >
    <hs-app-gear-action (click)="openErrorLogModal()"
      >Error Log</hs-app-gear-action
    >
    <hs-app-gear-action
      (click)="toggleLayoutLocked()"
      [isDisabled]="lockLayoutDisabled"
      >{{ lockLayout ? 'Unlock' : 'Lock' }} Layout</hs-app-gear-action
    >

    <hs-app-footer [ngClass]="env">
      <hs-app-footer-item *ngIf="dockerTag">
        <strong>Version: </strong>
        {{ dockerTag }}
      </hs-app-footer-item>
      <hs-app-footer-item *ngIf="activeSession" (click)="copyToClipboard()">
        <strong>Accounts: </strong>
        {{ activeSession?.loadedAccountIds?.join(', ') }}
      </hs-app-footer-item>
      <hs-app-footer-item *ngIf="activeSession">
        <strong>Recon Date: </strong>
        {{ activeSession?.reconDate | date: 'mediumDate' }}
      </hs-app-footer-item>
      <hs-app-footer-item *ngIf="activeSession">
        <strong>Load Window Start Date: </strong>
        {{
          activeSession?.auxiliaryInfo?.LOAD_WINDOW_START_DATE
            | date: 'mediumDate'
        }}
      </hs-app-footer-item>
      <hs-app-footer-item
        *ngIf="activeSession && activeSession?.auxiliaryInfo?.BASIS_NAME"
      >
        <strong>Basis Name: </strong>
        {{ activeSession?.auxiliaryInfo?.BASIS_NAME }}
      </hs-app-footer-item>
      <hs-app-footer-item position="right">
        <hs-messaging-status-footer></hs-messaging-status-footer>
      </hs-app-footer-item>
    </hs-app-footer>

    <nf-panel-container class="h-100" *ngIf="panels.length > 0">
      <nf-panel
        mode="over"
        position="end"
        id="panel-catalog"
        [opened]="false"
        [autoFocus]="true"
        #heliosEndNav
        hsOutsideClick
        (clickOutside)="closeSideNav()"
      >
        <hs-panel-catalog
          [ngClass]="{
            'd-none': !(heliosEndNavContent === 'PanelCatalog')
          }"
          [panelMetadata]="panels"
          [layoutManager]="layoutManager"
          (closePanel)="toggleHeliosEndNav('PanelCatalog')"
          (dragSourcesCreated)="onDragSourcesCreated()"
        ></hs-panel-catalog>
        <hs-sessions-drawer
          [ngClass]="{
            'd-none': !(heliosEndNavContent === 'SessionsDrawer')
          }"
          (closePanel)="toggleHeliosEndNav('SessionsDrawer')"
          [isVisible]="heliosEndNavContent === 'SessionsDrawer'"
        ></hs-sessions-drawer>
        <hs-commands-drawer
          [ngClass]="{
            'd-none': !(heliosEndNavContent === 'CommandsDrawer')
          }"
          (closePanel)="toggleHeliosEndNav('CommandsDrawer')"
          [isVisible]="heliosEndNavContent === 'CommandsDrawer'"
        ></hs-commands-drawer>
        <hs-workspace-catalog
          [ngClass]="{
            'd-none': !(heliosEndNavContent === 'WorkspaceCatalog')
          }"
          (closePanel)="toggleHeliosEndNav('WorkspaceCatalog')"
          [isVisible]="heliosEndNavContent === 'WorkspaceCatalog'"
        ></hs-workspace-catalog>
        <hs-user-preferences-drawer
          [ngClass]="{
            'd-none': !(heliosEndNavContent === 'UserPreferences')
          }"
          (closePanel)="toggleHeliosEndNav('UserPreferences')"
          [isVisible]="heliosEndNavContent === 'UserPreferences'"
        ></hs-user-preferences-drawer>
      </nf-panel>

      <hs-comments-drawer-frame
        *ngIf="hasAccessCommentary"
        #commentsDrawerFrame
        [isOpen]="commentaryDrawerOpen"
        [isRevealed]="!commentaryDeepLinkPending"
        [entityContext]="commentaryEntityContext"
        [commentaryAction]="commentaryAction"
        [commentaryActionSeq]="commentaryActionSeq"
        [accountId]="commentaryAccountId"
        [relatedAccountIds]="commentaryRelatedAccountIds"
        [userId]="commentaryUserId"
        [userDisplayName]="commentaryUserDisplayName"
        [threadIds]="commentaryThreadIds"
        [threadIdsSeq]="commentaryThreadIdsSeq"
        [commentId]="commentaryCommentId"
        (closed)="onCommentsDrawerClosed()"
        (deepLinkResolved)="onCommentaryDeepLinkResolved($event)"
      ></hs-comments-drawer-frame>

      <nf-panel-content>
        <div *nfLoader="layout == null || panels.length === 0"></div>
        <hs-layout-manager
          #layoutManager
          [panels]="panels"
          [layout]="layout"
          (layoutChanged)="handleLayoutChanged($event)"
          (panelFocused)="onPanelFocused($event)"
          (stackDestroyed)="stackDestroyed($event)"
          (stackActiveTabUpdate)="stackActiveTabUpdate($event)"
          [locked]="layoutLocked | async"
        ></hs-layout-manager>
      </nf-panel-content>
    </nf-panel-container>
  </hs-app-container>
</div>
